module.exports = __webpack_public_path__ + "static/home1-newsletter-e1cc3bbd22660bde5dd4f98a98c76f48.png";